module.exports = __webpack_public_path__ + "media/img/frontend_application/bottomnav/marker-6b19c5fdaed2b168e70486986cf55cd7.svg";